import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, withModifiers as _withModifiers, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/goods/shoucang-active.png'
import _imports_1 from '@/assets/image/goods/shoucang.png'
import _imports_2 from '@/assets/image/goods/like-active.png'
import _imports_3 from '@/assets/image/goods/like.png'
import _imports_4 from '@/assets/image/goods/unlike-active.png'
import _imports_5 from '@/assets/image/goods/unlike.png'


const _withScopeId = n => (_pushScopeId("data-v-bbceb348"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ShopItemAction" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = {
  key: 0,
  referrerPolicy: "no-referrer",
  src: _imports_0
}
const _hoisted_4 = ["title"]
const _hoisted_5 = {
  key: 0,
  referrerPolicy: "no-referrer",
  src: _imports_2,
  title: ""
}
const _hoisted_6 = ["title"]
const _hoisted_7 = {
  key: 0,
  referrerPolicy: "no-referrer",
  src: _imports_4
}
const _hoisted_8 = ["title"]


import { t } from '@/plugins/i18n'
import { shopFavorite, shopFavoriteCancel, handleShopBehavior } from '@/apis/shop'
import { ElMessage as message } from 'element-plus'


export default /*#__PURE__*/_defineComponent({
  props: {
  item: {
    type: Object,
    default: null
  },
  // 前端展示场景 1-搜索列表;2-猜你喜欢;3-店铺商品列表;4-商品详情;5-收藏;6-已购买;7-足迹;8-担当推荐;9-系统推荐;10-找相似;11-关联商品;
  showChannel: {
    type: Number,
    default: null
  }
},
  emits: ['unlike', 'cancelCollect'],
  setup(__props, { emit: emits }) {

const props = __props




// 收藏操作
const handleFavorite = () => {
  const formData = {
    shopCode: props.item.shopCode
  }
  if (props.item.favoriteFlag) {
    // 取消收藏
    // 请求前先反馈
    props.item.favoriteFlag = 0
    emits('cancelCollect', formData.shopCode)
    shopFavoriteCancel(formData).then(res => {
      if (res.code === '0') {
        // props.item.favoriteFlag = 0
        // emits('cancelCollect', formData.shopCode)
      }
    })
  } else {
    // 添加收藏
    // 请求前先反馈
    props.item.favoriteFlag = 1
    message.success(t('店铺收藏成功'))
    shopFavorite(formData).then(res => {
      if (res.code === '0') {
        // props.item.favoriteFlag = 1
        // message.success(t('店铺收藏成功'))
      }
    })
  }
}

// 喜欢和不喜欢操作
const handleLike = (behaviorFlag: number) => {
  const formData: any = {
    behaviorChannel: props.showChannel,
    shopCode: props.item.shopCode
  }
  if (behaviorFlag === props.item.behaviorFlag) {
    // 如果传入的状态为当前状态，就取消
    formData.behaviorFlag = 0
  } else {
    formData.behaviorFlag = behaviorFlag
  }
  // 请求前先反馈
  props.item.behaviorFlag = formData.behaviorFlag
  if (formData.behaviorFlag === 1) {
    message.success(t('感谢反馈，我们将为你推荐更加准确的店铺'))
  } else
  if (formData.behaviorFlag === 2) {
    emits('unlike', formData.shopCode)
  }
  handleShopBehavior(formData).then((res: any) => {
    if (res.code === '0') {
      // props.item.behaviorFlag = formData.behaviorFlag
      // if (formData.behaviorFlag === 1) {
      //   message.success(t('感谢反馈，我们将为你推荐更加准确的店铺'))
      // } else
      // if (formData.behaviorFlag === 2) {
      //   emits('unlike', formData.shopCode)
      // }
    }
  })
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["ShopItemAction-top", __props.item.behaviorFlag === 1 || __props.item.behaviorFlag === 2 ? 'selected' : 'default'])
    }, [
      _createElementVNode("div", {
        class: "ShopItemAction-top-icon tstnc",
        onClick: _withModifiers(handleFavorite, ["prevent","stop"])
      }, [
        (__props.item.favoriteFlag === 1)
          ? (_openBlock(), _createElementBlock("img", _hoisted_3))
          : (_openBlock(), _createElementBlock("img", {
              key: 1,
              referrerPolicy: "no-referrer",
              src: _imports_1,
              title: _unref(t)('收藏店铺')
            }, null, 8, _hoisted_4))
      ], 8, _hoisted_2),
      _withDirectives(_createElementVNode("div", {
        class: "ShopItemAction-top-icon tstnc",
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (handleLike(1)), ["prevent","stop"]))
      }, [
        (__props.item.behaviorFlag === 1)
          ? (_openBlock(), _createElementBlock("img", _hoisted_5))
          : (_openBlock(), _createElementBlock("img", {
              key: 1,
              referrerPolicy: "no-referrer",
              src: _imports_3,
              title: _unref(t)('多为我推荐此类型店铺')
            }, null, 8, _hoisted_6))
      ], 512), [
        [_vShow, __props.item.behaviorFlag !== 2]
      ]),
      _withDirectives(_createElementVNode("div", {
        class: "ShopItemAction-top-icon tstnc nolike",
        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (handleLike(2)), ["prevent","stop"]))
      }, [
        (__props.item.behaviorFlag === 2)
          ? (_openBlock(), _createElementBlock("img", _hoisted_7))
          : (_openBlock(), _createElementBlock("img", {
              key: 1,
              referrerPolicy: "no-referrer",
              src: _imports_5,
              title: _unref(t)('不再推荐此店铺')
            }, null, 8, _hoisted_8))
      ], 512), [
        [_vShow, __props.item.behaviorFlag !== 1]
      ])
    ], 2)
  ]))
}
}

})